import { type CountryMapping } from '@/interfaces/helpers/ILanguage'
import { languageMappings } from '@/application/helpers/brandMappings'
import { useAppStore } from '@/stores/portal-stores/general-stores/app'

export function extractLanguage(url: string): CountryMapping | undefined {
  for (const brand in languageMappings) {
    const brandMapping = languageMappings[brand]

    for (const countryMapping of brandMapping.countries) {
      if (countryMapping.urls.some((country) => url.includes(country.url))) {
        return countryMapping
      }
    }
  }

  return undefined
}

export const getCountryMapping = (locale: string | undefined): CountryMapping => {
  // We want to find our local key to get the correct API URL
  // We search in brandMappings.ts to first finding our correct brand
  // After we check that the locale string is in our known locals on that brand and return the key from the correct language with the correct brand.
  const appStore = useAppStore()
  const brand = appStore.getBrand()
  console.log('brand on android?', brand)

  for (const brandMapping of languageMappings) {
    if (brandMapping.brand === brand) {
      for (const countryMapping of brandMapping.countries) {
        if (
          locale &&
          countryMapping.locales.some((lo: string) => lo.toLowerCase() === locale.toLowerCase())
        ) {
          return countryMapping
        }
      }
    }
  }
  return {} as CountryMapping
}

export const getLocaleBasedOnDeviceLocale = (locale: string | undefined): string => {
  const appStore = useAppStore()
  const brand = appStore.getBrand()

  for (const brandMapping of languageMappings) {
    if (brandMapping.brand === brand) {
      for (const countryMapping of brandMapping.countries) {
        if (locale && countryMapping.locales.some((lo: string) => lo === locale)) {
          return countryMapping.locale
        }
      }
    }
  }
  return ''
}
